export function ensureUrlHasProtocol(url: string): string {
    if (!url.startsWith("http://") && !url.startsWith("https://")) {
        url = url.replace(/^http[s:]?[s:]?\/(?!\/)/g, "");
        url = url.replace(/^http[s:]?:+(?!\/)/g, "");

        url = "https://" + url;
    }

    return url;
}

export const ensureNoProtocol = (url: string) =>
    url.replace(/^https?:\/\//, "");

export function isValidHttpsUrl(value: string): boolean {
    try {
        return new URL(value).protocol === "https:";
    } catch {
        return false;
    }
}

/**
 * Returns true only when the url resolves to an http(s) scheme. Schemes such as
 * javascript:, data: or vbscript: return false, so this can be used to reject
 * unsafe link targets before rendering them as clickable links. Relative and
 * schemeless inputs (e.g. "example.com/path") resolve to http(s) and pass.
 * Unlike isValidHttpsUrl this also accepts http: and bare domains, which is
 * what link rendering needs.
 */
export function isHttpUrl(url: string): boolean {
    let parsed: URL;
    try {
        // Resolve against an absolute base so relative/schemeless inputs parse
        // instead of throwing; the host of the base is irrelevant here.
        parsed = new URL(url, "https://example.com");
    } catch {
        return false;
    }
    return parsed.protocol === "http:" || parsed.protocol === "https:";
}

export function cutQueryStringAndFragment(url: string): string {
    return url.split("?")[0]?.split("#")[0] || "";
}

export function ensureNakedDomainWithProtocol(url: string) {
    if (url.length === 0) return "";

    try {
        const parsedUrl = new URL(ensureUrlHasProtocol(url));
        return "https://" + parsedUrl.hostname;
    } catch {
        return url;
    }
}

export function ensureNakedDomain(url: string) {
    if (url.length === 0) return "";

    try {
        const parsedUrl = new URL(ensureUrlHasProtocol(url));
        return parsedUrl.hostname;
    } catch {
        return url;
    }
}
